import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteContractsId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const useDeleteContractMutation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((contractId: string) =>
			deleteContractsId(contractId),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["contracts"], exact: false });
		},
	});
};
